"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/media-has-caption */
var react_1 = __importStar(require("react"));
var ffmpeg_1 = require("@ffmpeg/ffmpeg");
var Loader_1 = __importDefault(require("./Loader"));
var ffmpeg = ffmpeg_1.createFFmpeg({
    corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
    log: false
});
var VideoEditor = function (_a) {
    var video = _a.video, onEdit = _a.onEdit, onProcessing = _a.onProcessing, asButtonView = _a.asButtonView;
    react_1.useEffect(function () {
        var processVideo = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c, thumb, blobThumb;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // Write the file to memory
                        _b = (_a = ffmpeg).FS;
                        _c = ["writeFile", "video.mp4"];
                        return [4 /*yield*/, ffmpeg_1.fetchFile(video)];
                    case 1:
                        // Write the file to memory
                        _b.apply(_a, _c.concat([_d.sent()]));
                        // Run the FFMpeg command
                        return [4 /*yield*/, ffmpeg.run("-i", "video.mp4", "-ss", "00:00:00.000", "-vframes", "1", "thumbnail.png")];
                    case 2:
                        // Run the FFMpeg command
                        _d.sent();
                        thumb = ffmpeg.FS("readFile", "thumbnail.png");
                        blobThumb = new Blob([thumb.buffer], { type: "image/png" });
                        // return { blobOutput, blobThumb };
                        return [2 /*return*/, { blobThumb: blobThumb }];
                }
            });
        }); };
        var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
            var blobThumb;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!onEdit) return [3 /*break*/, 2];
                        if (onProcessing) {
                            onProcessing(true);
                        }
                        return [4 /*yield*/, processVideo()];
                    case 1:
                        blobThumb = (_a.sent()).blobThumb;
                        if (onProcessing) {
                            onProcessing(false);
                        }
                        onEdit(video, blobThumb);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var load = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!ffmpeg.isLoaded()) return [3 /*break*/, 2];
                        return [4 /*yield*/, ffmpeg.load()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, handleSave()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        load();
    }, [video, onEdit, onProcessing]);
    if (asButtonView) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(Loader_1.default, { loading: true });
};
exports.default = VideoEditor;
